import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../..";
export const Chapter = {
    list: (req) => apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/chapter/`,
        method: "GET",
        query: req === null || req === void 0 ? void 0 : req.query,
    }),
    retrieve: (req) => apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/academy/v1/chapter/${req.path.id}`,
        method: "GET",
    }),
};
//# sourceMappingURL=chapter.js.map